// extracted by mini-css-extract-plugin
export default {"slotHighlighted":"G6PZfw"};